import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import "./Logo.scss";

const Logo = ({ className }) => {
  return (
    <div className={`logoContainer ${className}`}>
      <Link to="/">
        <img
          src={require("../../assets/logo/logo-text-horizontal.png")}
          alt="logo"
        />
      </Link>
    </div>
  );
};

Logo.propTypes = {
  className: PropTypes.string
};

export default Logo;
